/**
 * @author Johann Esneider Casallas Becerra
 * @Copyright (c) Infotrack. All rights reserved.
 */

import ModeloProducto from "Infotrack@Modelos/smartStock/gestionProducto";
import ModeloMaximosMinimos from "Infotrack@Modelos/smartStock/maximosMinimos";
import IMaximosMinimos from "Infotrack@Modelos/smartStock/maximosMinimos/entidades/IMaximosMinimos";
import IBodegaMaxMinFiltros from "Infotrack@Modelos/smartStock/maximosMinimos/entidades/bodegaMaxMinFiltros";
import IFiltrosItem from "Infotrack@Modelos/smartStock/gestionProducto/entidades/filtrosItem";
import notificacionGlobal from "@infotrack/presentacion-componentes/notificacionGlobal";
import { IPaginador } from "@infotrack/presentacion-transversales/interfacesComunes";

export default class MaximosMinimosCM {
    private modeloMaximosMinimos: ModeloMaximosMinimos;
    private modeloProducto : ModeloProducto;

    constructor() {
        this.modeloMaximosMinimos = new ModeloMaximosMinimos();
        this.modeloProducto = new ModeloProducto();
    }

    public consultarListaProductoPrincipal = (filtros: IFiltrosItem) =>
  this.modeloProducto
    .consultarListaProductoPrincipal({ items: filtros })
    .then(({ data }) => data);

    public consultarListaItems = async (paginador: IPaginador, filtro: IFiltrosItem) => {
        const respuesta = await this.modeloProducto.consultarListaProductoPrincipal({
            items: filtro,
            paginador: paginador,
        });
      
        return respuesta.data;
    };

    


    public ConsultarListaMaximoMinimoPorBodega(BodegaId: number) {
        return this.modeloMaximosMinimos
            .ConsultarListaMaximoMinimoPorBodega(BodegaId)
        .then(({ data: { Entidades } }) => Entidades);
    }

    public async crearMaximoMinimo(maxMin: IMaximosMinimos) {
        await this.modeloMaximosMinimos.crearMaximoMinimo(maxMin);
    }

    public async editarMaximoMinimo(maxMin: IMaximosMinimos) {
        await this.modeloMaximosMinimos.editarMaximoMinimo(maxMin);
    }

    public async eliminarMaximoMinimo(maxMin: IMaximosMinimos) {
        await this.modeloMaximosMinimos.eliminarMaximoMinimo(maxMin);
    }

    public validarCampos = (maxMin: IMaximosMinimos) => {
        if (maxMin.ItemId === 0) {
            notificacionGlobal('maximosMinimos.inputAlerta.nombreProducto', 6000, 'warning', true);
            return false;
        }
        if (Number(maxMin.NivelMinimo) <= 0) {
            notificacionGlobal('maximosMinimos.inputAlerta.valorMinimoInvalido', 6000, 'warning', true);
            return false;
        }
        if (Number(maxMin.NivelMaximo) <= 0) {
            notificacionGlobal('maximosMinimos.inputAlerta.valorMaximoInvalido', 6000, 'warning', true);
            return false;
        }
        if (Number(maxMin.NivelMinimo) > Number(maxMin.NivelMaximo)) {
            notificacionGlobal('maximosMinimos.inputAlerta.valorMinimoMayor', 6000, 'warning', true);
            return false;
        }
        return true
    };
}

